<div class="sidenav-example">
  <div class="example-header">Header</div>

  <atlas-sidenav-container class="example-gap-container">
    <atlas-sidenav
      #sidenav
      mode="side"
      opened
      class="example-sidenav mat-body"
      [fixedInViewport]="options.value.fixed"
      [fixedTopGap]="options.value.top"
      [fixedBottomGap]="options.value.bottom">
      {{options.value.fixed ? 'Fixed' : 'Non-fixed'}} Sidenav
    </atlas-sidenav>
  
    <atlas-sidenav-content [formGroup]="options">
      <p><atlas-checkbox formControlName="fixed">Fixed</atlas-checkbox></p>
      <div class="row">
        <div class="col-2 col-lg">
          <atlas-input
            formControlName="top"
            type="number"
            label="Top gap">
          </atlas-input>
        </div>
      </div>
      <div class="row">
        <div class="col-2 col-lg">
          <atlas-input
            formControlName="bottom"
            type="number"
            label="Bottom gap">
          </atlas-input>
        </div>
      </div>
      <button
        atlas-contained-button
        color="accent"
        (click)="sidenav.toggle()">
        Toggle
      </button>
    </atlas-sidenav-content>
  </atlas-sidenav-container>
  
  <div class="example-footer">Footer</div>
</div>
